import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { ITagResult } from '../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtConnectionSettings } from '../../../../types/ISiteSettingsForSiteAdmin';

export type IUpdateAnalyticsExtConnectionSettingsResult = ITagResult & IAnalyticsExtConnectionSettings;

export class UpdateAnalyticsExtConnectionSettingsRequest extends TagRequest<IAnalyticsExtConnectionSettings, IUpdateAnalyticsExtConnectionSettingsResult> {
  constructor(params: IAnalyticsExtConnectionSettings) {
    super('analyticsextensions', 'updateAnalyticsExtensionsConnection', params);
  }
}
